import React, {Component} from "react";
import { Helmet, HelmetProvider } from 'react-helmet-async';
import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import { SM_URL, SM_LANG } from "../i18n";
import { setViewport } from "../store/navSlice";

import Viewer from "./Viewer";
import Header from "./Header";
import Drawer from "./Drawer";
import ConfigFormBuilder from "./ConfigFormBuilder";
import YourNitrum from "./YourNitrum";
import Nav from "./Nav";
import NavNitrum from "./NavNitrum";
import Popover from "./Popover";
import Modal from "./Modal";
import Tooltip from "./Tooltip";
import "./App.scss";

const mapDispatch = { setViewport };

class App extends Component {
  constructor(props) {
    super(props);
    this.setViewportInfo();
  }

  setViewportInfo() {
    const width = window.innerWidth;
    let breakpoint;
    let isMobile = false;
    let isTablet = false;
    let isDesktop = false;
    
    if (width < 576) {
      breakpoint = "xs";
      isMobile = true;
    } else if (width <= 767) {
      breakpoint = "sm";
      isTablet = true;
    } else if (width <= 991) {
      breakpoint = "md";
      isTablet = true;
    } else if (width <= 1199) {
      breakpoint = "lg";
      isDesktop = true;
    } else if (width <= 1439) {
      breakpoint = "xl";
      isDesktop = true;
    } else {
      breakpoint = "xxl";
      isDesktop = true;
    }

    this.props.setViewport({
      width,
      breakpoint,
      isMobile,
      isTablet,
      isDesktop
    });
  }

  render() {
    const { t } = this.props;
    const useDiacritics = /^(cs|pl)$/.test(SM_LANG);
    const ogImage = "/getmedia/00081dc2-305b-4def-b8f3-f2b528cf5619/Social-share-nitrum-visualiser.jpg";

    return (
      <HelmetProvider>
        <div className={`app ${useDiacritics ? 'font-diacritics' : ''}`}>
          <Helmet>
            <title>{ t("meta_title") }</title>
            <meta name="description" content={ t("meta_description") } />
            <meta property="fb:app_id" content="1082535715148861" />
            <meta name="og:site_name" content="Sunrise Medical" />
            <meta property="og:title" content={ t("meta_title") } />
            <meta property="og:description" content={ t("meta_description") } />
            <meta property="og:image" content={ SM_URL + ogImage } />
            <meta property="og:image:width" content="1200" />
            <meta property="og:image:height" content="627" />
            <meta property="og:url" content={`${SM_URL}/visualiser/nitrum`} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:image:alt" content={ t("meta_title") } />
            <meta name="twitter:site" content="@sunrisemedical" />
          </Helmet>
          <Popover />
          <Modal />
          <Tooltip />
          <Viewer />
          <Header />
          <Drawer>
            <ConfigFormBuilder />
          </Drawer>
          <YourNitrum />
          <Nav />
          <NavNitrum desktop={true} />
        </div>
      </HelmetProvider>
    );
  }
}

export default withTranslation()( connect(null, mapDispatch)(App) );